import { Editor } from '@tinymce/tinymce-react';
import { useEffect, useRef } from 'react';

const TinyEditor = ({ inputValue, handleChangeCallBack, labelName, inputName, isMandatory = false, editorHeight = 400 }) => {
    const editorRef = useRef(null);

    useEffect(() => {
        if (editorRef.current) {
            const focusinHandler = (e) => {
                if (e.target instanceof Element && e.target.closest(".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root") !== null) {
                    e.stopImmediatePropagation();
                }
            };

            document.addEventListener('focusin', focusinHandler);

            return () => {
                document.removeEventListener('focusin', focusinHandler);
            };
        }
    }, [editorRef]);

    const editorConfig = {
        height: editorHeight || 400,
        menubar: true,
        plugins: [
            'advlist', 'autolink', 'lists', 'link', 'charmap', 'preview',
            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
            'insertdatetime', 'media', 'table', 'help', 'wordcount',
            'emoticons', 'hr', 'pagebreak', 'nonbreaking', 'directionality'
        ],
        toolbar:
            'undo redo | blocks fontfamily fontsize | ' +
            'bold italic underline strikethrough forecolor backcolor | ' +
            'alignleft aligncenter alignright alignjustify | ' +
            'bullist numlist outdent indent | link media emoticons | ' +
            'hr pagebreak | table | removeformat code fullscreen | help',
        font_family_formats:
            'Arial=arial,helvetica,sans-serif;Courier New=courier new,courier;Times New Roman=times new roman,times;Verdana=verdana,geneva;',
        fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        // forced_root_block: false,
        // br_newline_selector: 'br',
        setup: (editor) => {
            editor.on('keydown', (e) => {
                if (e.key === 'Enter') {
                    editor.execCommand('InsertLineBreak');
                    e.preventDefault();
                }
            });
        },
        paste_as_text: false,
        paste_webkit_styles: "all",
        paste_retain_style_properties: "all",
        paste_merge_formats: true,
        valid_children: "+body[style],+body[link]",
        extended_valid_elements: "span[style],font[face|size|color|style],div[style],p[style]",
        paste_data_images: true,
        branding: false,
        promotion: false
    };



    const handleEditorChange = (content) => {
        handleChangeCallBack(inputName, content);
    };

    return (
        <>
            <div className="col-xl-2 col-sm-2">
                <div className="card-body p-0">
                    <label htmlFor={labelName} className="form-label text-primary">
                        {labelName} {isMandatory && <span className="required">*</span>}
                    </label>
                </div>
            </div>
            <div className="col-xl-10 col-sm-10">
                <div
                    className="card border-0 shadow-sm"
                    style={{
                        borderRadius: '2px',
                        overflow: 'hidden',
                        backgroundColor: '#fdfdfd',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
                    }}
                >
                    <div
                        className="card-body p-3"
                        style={{
                            border: '1px solid #dee2e6',
                            borderRadius: '8px',
                            backgroundColor: '#ffffff',
                            zIndex: 0,
                        }}
                    >
                        <Editor
                            tinymceScriptSrc="/tinymce/tinymce.min.js"
                            onInit={(_evt, editor) => (editorRef.current = editor)}
                            value={inputValue || ''}
                            init={{
                                ...editorConfig,
                                content_style: `
                            body {
                                font-family: 'Roboto', 'Segoe UI', sans-serif;
                                font-size: 15px;
                                padding: 2px;
                                background-color: #ffffff;
                                color: #212529;
                            }
                            `,
                                base_url: '/tinymce',
                            }}
                            onEditorChange={handleEditorChange}
                        />
                    </div>
                </div>

            </div>
        </>
    );
};

export default TinyEditor;
